import { Checkbox, RadioButton } from '@weareopenr/component-library';
import { Autocomplete, TextField } from '@mui/material';
import styles from '../MenuModal/MenuModal.module.scss';
import {
  Control,
  FieldErrors,
  useController,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form';
import { EntitySource } from '../../constants';
import { IOptionGroupValues } from '../CreateOptionGroupModal/types';

interface IProductRangeSelectorProps {
  ranges: { range_id: string; name: string }[];
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  errors: FieldErrors<any>;
  watch: UseFormWatch<any>;
  clearErrors: UseFormClearErrors<any>;
  trigger?: UseFormTrigger<IOptionGroupValues>;
  productType: 'BUNDLE' | 'STANDARD';
  control: Control<any>;
  isDisabled?: boolean;
}

export const ProductRangeSelector = ({
  ranges,
  register,
  watch,
  errors,
  clearErrors,
  trigger,
  productType,
  control,
  isDisabled = false,
}: IProductRangeSelectorProps) => {
  const source = watch('source');

  const {
    field: { onChange, value },
  } = useController({
    control,
    name: 'ranges',
  });

  const selectedRanges = value ? value.map((rangeId) => ranges.find((range) => range.range_id === rangeId)) : [];

  return (
    <>
      <RadioButton name={'source'} value={EntitySource.LIBRARY} register={register} disabled={isDisabled}>
        Use Product Library
      </RadioButton>
      <RadioButton
        name={'source'}
        value={EntitySource.RANGES}
        register={register}
        disabled={!ranges || ranges?.length === 0 || isDisabled}
      >
        Use Product Range(s)
      </RadioButton>

      <Autocomplete
        isOptionEqualToValue={(option, value) => value.range_id === option.range_id}
        onChange={(e, data) => {
          if (isDisabled) {
            return;
          }
          onChange(data.map((range) => range.range_id));

          if (productType === 'STANDARD') {
            trigger('modifiers');
          }
        }}
        renderInput={(params) => (
          <TextField
            label="Product Range"
            {...params}
            error={!!errors.ranges}
            helperText={errors.ranges?.message}
            disabled={isDisabled}
          />
        )}
        disableClearable={isDisabled}
        options={ranges || []}
        value={selectedRanges}
        getOptionLabel={(option) => (typeof option === 'string' ? option : option?.name)}
        multiple
        onFocus={() => clearErrors('ranges')}
        disabled={source === EntitySource.LIBRARY}
        className={styles['autocomplete']}
        limitTags={2}
        renderOption={(props, option, { selected }) => {
          return (
            <li key={option.range_id} {...props}>
              <Checkbox checked={selected} onChange={() => {}} disabled={isDisabled} />
              {option.name}
            </li>
          );
        }}
      />
    </>
  );
};
